/**
 * Serialize a form into an associative array and append custom properties if needed
 *
 * @param  Object merge     Additional attributes we may wish to append
 *
 * @return Object           Returns an associactive array (object in JS)
 *
 * @author Aleš Bolka <ales@xooltime.com>
 */
$.fn.formDataObject = function(merge)
{
    var result = {};
    var data;
    var element;
    var ii;
    merge = merge || {};

    if (!this.is('form')) {
        return result;
    }

    data = this.serializeArray();

    for (ii = 0; ii < data.length; ii++) {
        if (result[data[ii].name] !== undefined) {
            if (!result[data[ii].name].push) {
                result[data[ii].name] = [result[data[ii].name]];
            }

            result[data[ii].name].push(data[ii].value || '');
        } else {
            result[data[ii].name] = data[ii].value || '';
        }
    }

    /* Collect append the data from custom select (modified bootstrap dropdown) menus in the form */
    this.find('.js-form-dropdown').each(function() {
        if (this.dataset.name === undefined || !this.dataset.name.length) {
            return 1;
        }

        result[this.dataset.name] = this.dataset.value || '';
    });

    for (ii in merge) {
        result[ii] = merge[ii];
    }

    return result;
};

/**
 * Bind all instances of the js-form-dropdown to behave like a select HTML element
 *
 * @return jQueryHandle  Returns the same handle that the method was called on
 *
 * @author Aleš Bolka <ales@xooltime.com>
 */
$.fn.bindFormDropdown = function (callback) {
    callback = typeof callback === 'function' ? callback : function(){};
    this.find('.js-form-dropdown').each(function() {
        var $btn = $(this);

        $btn.siblings('.dropdown-menu').on('click', '.js-form-option', function() {
            $btn.text(this.innerHTML);
            $btn.attr('data-value', this.dataset.value);

            $btn.trigger('change');
            callback($btn[0]);
        });
    });

    return this;
}

/**
 * Reset a form including the dropdown
 *
 * @return {self}
 *
 * @author Aleš Bolka <ales@xooltime.com>
 */
$.fn.formReset = function () {
    if (!this.is('form')) {
        return this;
    }

    this[0].reset();

    this.find('.js-form-dropdown + .dropdown-menu').find('.js-option-default').click();
    return this;
}
